import styled from 'styled-components';
import { color } from 'theme';
import Card from 'components/Card';
import { GREY_50 } from '../../../constants';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: auto;
`;

export const SumaryContainer = styled(Card)`
    display: flex;
    padding: 1.5rem 0;
    align-items: center;
    
    & > *:not(:first-child) {
        border-left: 1px solid ${color('border.divider')};
    }
`;

export const ChartWrapper = styled.div`
    width: 100%;
    height: 300px;
`;

export const TooltipContainer = styled.div`
    display: flex;
    width: 10.5rem;
    padding: 0.75rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
    border-radius: 0.375rem;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.65) 100%), #8692D0;
    color: ${GREY_50};
`;
